export const BaseURl = 'https://liveapi.meander.software/'
// export const BaseURl = 'http://localhost:8085/'

export const ModeId = '65c9e836ef719d3c44940a99'


const userDataCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('userDAta='));

export let userData = {};
if (userDataCookie) {
    userData = JSON.parse(userDataCookie.split('=')[1]);
} else {
}


export const getLocalData = () => {
    const data = localStorage.getItem('Filez_authUsername');
    try {
        return data ? JSON.parse(data) : null;
    } catch (error) {
        return data;
    }
};